import { get } from "./helpers";

export const fetchBuildInfo = async () => {
  const url = `/assets/build`;

  const result = await get(url);
  return result.data;
};
